export enum TimeSeriesField {
  Fuktighet,
  Plast, 
  BP
}
